import Lenis from 'lenis';

export function initLenisSmoothScroll() {
    const lenis = new Lenis({
        duration: 1.8,         // entspricht smooth: 1.8 bei ScrollSmoother
        smoothWheel: true,
        smoothTouch: false,    // wie smoothTouch: false
        normalizeWheel: true,  // wie normalizeScroll: true
        prevent: (node) => node.closest('.dcCookieModal') !== null,
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
}